import * as _ from 'lodash';
import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { EventTreeService } from "app/Shared/Component/event-tree/event-tree.service";
import { ConstantService } from "app/Shared/Services/constant-service";
import { GridService } from "app/Shared/Services/grid.service";
import { takeUntil } from "rxjs/operators";
import { CatAnalyticsService } from "./cat-analytics.service";
import { Subject,Subscription } from 'rxjs';
import { UserService } from "app/Shared/Services/user.service";
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { CatAnalyticsParentPayload } from "./cat-analytics.model";
import { MenuItem, MessageService,ConfirmationService } from 'primeng/api';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { Router } from "@angular/router";
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/CAT-ROE-Viewer-Columns.json';
import { NgClass, DatePipe, DecimalPipe, CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TreeTable, TreeTableModule } from "primeng/treetable";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { FormsModule } from '@angular/forms';
import { CatalystCommentViewerComponent } from 'app/Shared/Component/catalyst-comment-viewer/catalyst-comment-viewer.component';
import { asBlob, generateCsv } from 'export-to-csv';
import saveAs from 'file-saver';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { DatepickerCalendarComponent } from 'app/Shared/Component/datepicker-calendar/datepicker-calendar.component';
import { DatepickerService } from 'app/Shared/Component/datepicker-calendar/datepicker.service';

@Component({
    selector: 'app-cat-analytics',
    templateUrl: './cat-analytics.component.html',
    styleUrls: ['./cat-analytics.component.scss'],
    imports: [ButtonModule, TableModule, NgClass, CommonModule, MatProgressSpinnerModule,
        DecimalPipe, ToastModule, TreeTableModule, ConfirmDialogModule,
        MatChipsModule, MatTooltipModule, DialogModule, ContextMenuModule, FormsModule, CatalystCommentViewerComponent,
        CommonModule, MatIconModule, MatButtonModule, MatDividerModule, DatepickerCalendarComponent
    ]
})
export class CatAnalytics implements OnInit {
  gridColumns = GridColumnsJSON["CAT-ROE-Grid-Columns"];
  @ViewChild(('tt')) tt!: TreeTable|any;
  // @ViewChild(ContextMenuComponent) public ContextMenuObject!: ContextMenuComponent;
  @ViewChild('cm') cm!: ContextMenu;
  subscription!: Subscription;
  treeData: any;
  percentageChange: number = 10;
  isVisible = false;
  isDataLoading: boolean = true;
  cols :any= [];
  groupNames: Array<string> = [];
  fieldNames: Array<string> = [];
  rows: number;
  reportDate: any;
  activeCategory: string = 'Flags';
  private ngUnsubscribe:any = new Subject();
  activeFilters: Array<any> = [{type: 'Categories',value:'Flags'}];
  groupName: string = '';
  assetClass: string = '';
  filterByName: string = '';
  buttonCaption: string = 'Expand';
  catAnalyticsParentPayload: CatAnalyticsParentPayload | any;
  sortClickCounter: number = 0;
  sortData:any = { field: '', order: 0};
  catAnalyticsDate = [];
  selectedRowData: any = [];
  commentReportDates: any = [];
  totalCommentCount: number = 0;
  items:MenuItem[] | any;
  commentCriteria: any;
  commentField?: any;

  constructor(public constantService: ConstantService,
    public eventTreeService: EventTreeService,
    private catAnalyticsService: CatAnalyticsService,
    public userService: UserService,
    public messageService: MessageService,
    private sortPipe: SortPipe,
    public confirmationService: ConfirmationService,
    private router:Router,
    private gridService: GridService,
    private datepickerService: DatepickerService,
    private emitterService: EmitterService) {
    this.rows = 50;
  }

  ngOnInit() {
    this.selectedRowData = [];
    this.reportDate = this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.userService.CATAnalyticsLastExecutionReportDate));
    this.getGroupsForCatAnalyatics();
    this.getColumns();

    /* Reload the screen while changing MPID */
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.groupName = this.assetClass = this.filterByName = '';
        this.activeCategory = 'Flags';
        this.activeFilters = [{type: 'Categories', value:'Flags'}];
        this.getGroupsForCatAnalyatics();
        this.getColumns();
      }
    });

    this.items = [
      {
          label: 'Add Comment',
          command: () => {
            this.sendContextMenuParameters(this.commentCriteria, this.commentField);
          }
      },      
  ];
  }

  OnHeaderClick(colField: any) {
    this.sendPreparedParams('Header-Comments', [colField]);
    this.openCatalystCommentViewer(false, true);
  }
  openCatalystCommentViewer(isDisplayDateRangeFilter: boolean, isDisplayAddCommentForm: boolean) {
    this.catAnalyticsService.isOpenCommentViewer = true;
    this.catAnalyticsService.isDisplayDateRangeFilter = isDisplayDateRangeFilter;
    this.catAnalyticsService.isDisplayAddCommentForm = isDisplayAddCommentForm;
  }
  sendContextMenuParameters(item: any, fieldHeader: any) {
    if(fieldHeader.length > 0) {
      this.selectedRowData = Object.assign(item, {commentSection: 'Field-Comments', optedDay: fieldHeader, reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate), groupName: this.groupName, assetClass: this.assetClass});
      this.selectedRowData = {...this.selectedRowData};
    }
    this.openCatalystCommentViewer(false, true);
  }
  sendPreparedParams(commentCriteria: any, fieldHeader?: any) {
    this.selectedRowData = {commentSection: commentCriteria, optedDay: fieldHeader, reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate), groupName: this.groupName, assetClass: this.assetClass};
    if(!('fieldName' in this.selectedRowData) && this.filterByName!=='') {
      this.selectedRowData["fieldName"] = this.filterByName;
    }
  }

  setReportDate() {
    this.reportDate = this.userService.getyyyyMMddDateFormate(this.reportDate);
  }
  selectNextDate() {
    let newDate = this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.reportDate));
    this.reportDate = (newDate.setDate(newDate.getDate() + 1));
    this.reportDate = this.userService.getyyyyMMddDateFormate(this.reportDate);
    this.getColumns('dateFilter');
  }
  selectBackDate() {
    let newDate = this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.reportDate));
    this.reportDate = (newDate.setDate(newDate.getDate() - 1));
    this.reportDate = this.userService.getyyyyMMddDateFormate(this.reportDate);
    this.getColumns('dateFilter');
  }
  getGroupsForCatAnalyatics() {
    this.catAnalyticsService.getGroups({
      "CATReporterIMID": this.userService.getActiveMPID(),
      "reportDate": this.userService.getyyyyMMddDateFormate(this.reportDate)
    })
    .subscribe({
        next: (data: any) => {
          this.groupNames = data.response.groupName
          this.getFilesName();
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
          this.isDataLoading = false;
        }
      });    
  }
  getFilesName() {
    this.catAnalyticsService.getFieldNames({
      "CATReporterIMID": this.userService.getActiveMPID(),
      "reportDate": this.userService.getyyyyMMddDateFormate(this.reportDate)
    })
    .subscribe({
      next: (data: any) => {
        this.fieldNames = data.response.fieldName;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  setActiveCategory(category:any) {
    this.activeCategory = category;
  }
  exportToCSV() {
    if(this.userService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    const filterData = { CATReporterIMID: this.userService.getActiveMPID(), reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate), limit: 5, groupName: this.groupName, assetClass: this.assetClass, filterBy: this.filterByName };
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });

    const filename='RSMS_CAT_Analytics_'+ this.userService.getActiveMPID()+'_'+ this.userService.getyyyyMMddDateFormate(new Date());

    this.eventTreeService.exportToCSV(this.treeData)
    .subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
          let data = dataset.Data;
          if (data.length > 0) {
            data.forEach((col:any) => {
              col.timeInForce = (typeof col.timeInForce === 'object' ? JSON.stringify(col.timeInForce) : col.timeInForce);
              col.handlingInstructions = (typeof col.handlingInstructions === 'object' ? JSON.stringify(col.handlingInstructions) : col.handlingInstructions);
              col = this.gridService.formatMultiDimensionalColumns(col, this.gridService.multiDimensionalColumns);
            });
            const options:any = {
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalSeparator: '.',
              showLabels: true,
              showTitle: true,
              title:filename,
              useTextFile: false,
              useBom: true,
              useKeysAsHeaders: true,
              filename: filename
            };
            const csv = generateCsv(options)(this.constantService.getExportDataForCATAnalytics(data, this.cols));
            const blob = asBlob(options)(csv);
            saveAs(blob, filename);
            this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
            this.userService.logUserActivity('Export CSV', null, {
              'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
              'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData)
            });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
            this.userService.logUserActivity('Export CSV', null, {
              'Text1': 'No data found',
              'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData)
            });
          }
      },
      error: (e) => {
        console.error(e);
      }
    });
  }
}
  sort(event:any,treeData:any) {
    if(this.sortClickCounter !== 3 &&(this.sortData.field === "" ||
    this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    } 
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      let data = this.sortPipe.transform(treeData, this.sortData.order, this.sortData.field,true);
      this.tt.value = data;
    } else {
    this.resetSort();
    }
  }
  resetSort() {
    this.tt.multiSortMeta[0].field = '';
    this.tt.multiSortMeta[0].order = 0;
   }
  removeFilterLabel(index:any, value:any) {
   if(this.activeFilters[index].type === 'assestClass') {
    this.assetClass = '';
   } else if(this.activeFilters[index].type === 'groupName') {
    this.groupName = '';
   } else if(this.activeFilters[index].type === 'Categories') {
    this.filterByName = '';
   } else if(this.activeFilters[index].type === 'Flags') {
    this.filterByName = '';
   }
   this.activeFilters.splice(index, 1);
   this.getCatAnalyticsData();
  }

  getCatAnalyticsData(activeFilterType?:string,activeFilterValue?:string) {
    this.isDataLoading = true;
    this.buttonCaption = 'Expand';
    if(activeFilterType && activeFilterValue) {
      let activeFilterIndex = this.activeFilters.findIndex(function (item, index) {
        return item.type === activeFilterType;
      });
      if(activeFilterIndex !== -1) {
        this.activeFilters[activeFilterIndex]= {type: activeFilterType ,value:activeFilterValue};
      } else {
        this.activeFilters.push({type: activeFilterType ,value:activeFilterValue});
      }
    }
    this.catAnalyticsParentPayload = {
      CATReporterIMID: this.userService.getActiveMPID(),
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate),
      limit: 5,
      groupName: this.groupName,
      assetClass: this.assetClass,
      filterBy: this.filterByName
    }
 
    this.catAnalyticsService.getCatAnalyticsData(this.catAnalyticsParentPayload)
    .subscribe({
      next: (Element: any) => {
        this.isDataLoading = false;
          let dataset: any = Element;
          this.treeData = [];
          if (dataset.response) {
            this.treeData = this.formatTreeData(false, dataset.response, this.filterByName ? true : false);
            this.eventTreeService.dataArray = [];
            this.eventTreeService.prepareData(this.treeData);
            let event = {
              node: this.treeData[0],
            } 
            if(event.node !== undefined) {
              event.node.expanded = true;
              this.nodeSelect(event);
            }
            /* Catch User Action Log */
            this.userService.logUserActivity("User Applied Filter", null, {
              'Text1': this.userService.userFirstName + ' Applied Filter in ' + this.constantService?.getApplicationName(),
              'Text2': 'User Filter Parameters: ' + JSON.stringify(this.catAnalyticsParentPayload)
            });
          }
      },
      error: (err: HttpErrorResponse) => {
        this.isDataLoading = false;
      }
    });
  }

  getData(activeFilterType?:string,activeFilterValue?:string) {
    this.buttonCaption = 'Expand';
    if(activeFilterType && activeFilterValue) {
      let activeFilterIndex = this.activeFilters.findIndex(function (item, index) {
        return item.type === activeFilterType;
      });
      if(activeFilterIndex !== -1) {
        this.activeFilters[activeFilterIndex]= {type: activeFilterType ,value:activeFilterValue};
      } else {
        this.activeFilters.push({type: activeFilterType ,value:activeFilterValue});
      }
    }
    let payload: any = {
      CATReporterIMID: this.userService.getActiveMPID(),
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate),
      limit: 5,
      groupName: this.groupName,
      assetClass: this.assetClass
    }

    this.catAnalyticsService.getCatAnalyticsData(payload)
    .subscribe({
      next: (Element: any) => {
        this.isDataLoading = false;
          let dataset: any = Element;
          this.treeData = [];
          if (dataset.response) {
            this.treeData = this.formatTreeData(false, dataset.response,  false);
            this.eventTreeService.dataArray = [];
            this.eventTreeService.prepareData(this.treeData);
            /* Catch User Action Log */
            this.userService.logUserActivity("User Applied Filter", null, {
              'Text1': this.userService.userFirstName + ' Applied Filter in ' + this.constantService?.getApplicationName(),
              'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
            });
          }
      },
      error: (err: HttpErrorResponse) => {
        this.isDataLoading = false;
      }
    });
  }
 
  exapandORcollapse(nodes:any, isAllLevel?:any) {
    if (this.buttonCaption === "Expand") {
      this.collapseAll(nodes)
      this.exapandAll(nodes,true, isAllLevel)
      this.buttonCaption = "Collapse"
    } else if (this.buttonCaption === "Collapse") {
      this.buttonCaption = "Expand"
      this.collapseAll(nodes);
    }
    //refresh the data
    this.treeData = [...this.treeData];
  }
  

  async exapandAll(nodes:any,isAllLevel:any,type:any) {
    for (let node of nodes) {
      if (node.children && isAllLevel) {
        this.isDataLoading = true;
        let payLoad: any = {
          CATReporterIMID: this.userService.getActiveMPID(),
          reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate),
          fieldName: node.data.fieldName,
          limit: 5,
          groupName: this.groupName,
          assetClass: this.assetClass
        }
        if (node.data.fieldValue) {
          payLoad.fieldValue = node.data.fieldValue
        }
        this.catAnalyticsService.getCatAnalyticsData(payLoad)
        .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: (Element: any) => {
              this.isDataLoading = false;
                let dataset: any = Element;
                if (dataset.response)
                  node.children = this.formatTreeData(true, dataset.response,node);
                if (node.expanded == false || node.expanded == undefined) {
                  node.expanded = true;
                  this.exapandAll(node.children,type==='one-level' ? false: true,type);
                }
                this.treeData = [...this.treeData];
                this.eventTreeService.dataArray=[];
                this.eventTreeService.prepareData(this.treeData);
            },    
            error: (err: HttpErrorResponse) => {
              this.isDataLoading = false;
            }
          }); 
      }
    }
    //refresh the data
    this.applyThreshold();
    this.treeData = [...this.treeData];
  }
  
  collapseAll(nodes:any) {
    for (let node of nodes) {
      if (node.children) {
        if (node.expanded == true || node.expanded == undefined) {
          node.expanded = false;
          this.collapseAll(node.children);
        }
      }
    }
    //refresh the data
    this.treeData = [...this.treeData];
    this.eventTreeService.dataArray=[];
    this.eventTreeService.prepareData(this.treeData);
  }
  getColumns(type?:string) {
    this.isDataLoading = true;
    this.getFilesName();
    this.catAnalyticsService.getCatAnalyticsRecentDate(
      {
        "CATReporterIMID": this.userService.getActiveMPID(),
        "reportDate": this.userService.getyyyyMMddDateFormate(this.reportDate),
      }
    )
    .subscribe({
      next: (data:any) => {
        this.cols = [
          { field: 'fieldNameValue', header: 'CAT Field' },
          { field: 'average5Days', header: '5 Day Avg', commentCount: 0 },
          { field: 'average30Days', header: '30 Day Avg', commentCount: 0 }
        ];
        this.commentReportDates = [];
        this.catAnalyticsDate = data.response.reportDate;
        this.catAnalyticsDate.forEach(element => {
          this.cols.push({ field: element, header: element, commentCount: 0 });
          this.commentReportDates.push(element);
        });

        this.getAllCommentCounts();
        if (type === 'dateFilter') {
          this.getCatAnalyticsData();
        } else {
          this.getData();
        }
      },
      error: (e) => {
        console.error(e);
      }
    });
  }
  showFilter() {
    this.isVisible = true;
  }

  getAllCommentCounts() {
    let payload: any = {
      "CATReporterIMID": this.userService.getActiveMPID(),
      "initialReportDate": (!_.includes(['average5Days', 'average30Days'], this.cols[this.cols.length-1]["field"]) ? this.cols[this.cols.length-1]["field"] : this.userService.getyyyyMMddDateFormate(this.reportDate)),
      "lastReportDate": this.userService.getyyyyMMddDateFormate(this.reportDate),
      "groupName": this.groupName,
      "assetClass": this.assetClass,
      "fieldName": this.filterByName
    }
    this.catAnalyticsService.getAllCatAnalyticsCommentCount(
      payload
    )    
    .subscribe({
      next: (data:any) => {
        let response = data.Data;
      if(response.length > 0) {
        /* Total Comment Count */
        const allCommentsField = response.filter((resObj:any) => resObj.reportDate==='AllComments');
        this.totalCommentCount = (allCommentsField.length > 0 ? allCommentsField[0]['totalComments'] : 0);
        /* All Average Days/Dates Comment Count */
        for(let i=0; i<this.cols.length; i++) {
          const filteredField = response.filter((resObj:any) => resObj.reportDate===this.cols[i]['field']);
          this.cols[i]['commentCount'] = (filteredField.length > 0 ? filteredField[0]['totalComments'] : 0);
        }
      }
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  nodeSelect(event:any) {
    this.isDataLoading = true;
    const node = event.node;
    if (event.node.expanded) { 
      let payLoad: any = {
        CATReporterIMID: this.userService.getActiveMPID(),
        reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate),
        fieldName: node.data.fieldName,
        limit: 5,
        groupName: this.groupName,
        assetClass: this.assetClass
      }
      if (node.data.fieldValue) {
        payLoad.fieldValue = node.data.fieldValue
      }
      this.catAnalyticsService.getCatAnalyticsData(payLoad)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (Element: any) => {
            this.isDataLoading = false;
            let dataset: any = Element;
            if (dataset.response)
              event.node.children = this.formatTreeData(true, dataset.response, event.node);
            event.node = this.highLightCell(event.node);
            //refresh the data
            this.eventTreeService.dataArray = [];
            this.eventTreeService.prepareData(this.treeData);
            this.treeData = [...this.treeData];
          },
          error: (err: HttpErrorResponse) => {
            this.isDataLoading = false;
          }
        });
      event.node.width = this.cols[0].width;
    }
    //refresh the data
    this.treeData = [...this.treeData];
  }
  nodeUnselect(event:any) {
    this.treeData = [...this.treeData];
    this.eventTreeService.dataArray = [];
    this.eventTreeService.prepareData(this.treeData);
  }

  highLightCell(node:any) {
    node.children.forEach((childNode:any) => {
      this.catAnalyticsDate.forEach((date)=> {
        childNode.data[date].parentPercentageDiff = node.data[date].parentPercentageDiff;
        childNode.data[date].parent30DayPercentageDiff = node.data[date].parent30DayPercentageDiff;
          if(childNode.data[date].childPercentageDiff >0 &&childNode.data[date].childPercentageDiff > childNode.data[date].thresholdPercentage) {
            childNode.data[date].cellStaus = true;
            let difference = childNode.data[date].childPercentageDiff - childNode.data[date].thresholdPercentage;
            if(difference <30) {
              childNode.data[date].class = 'FFFFCC float-center';
            }else if( difference> 30 && difference<50) {
              childNode.data[date].class = 'FFFF99 float-center';
            } else if(difference> 50 && difference<100) {
              childNode.data[date].class = 'FFFF00 float-center';
            }  else if(difference> 100 && difference<150) {
              childNode.data[date].class = 'FFCC99 float-center';
            } else if(difference> 150 && difference<200) {
              childNode.data[date].class = 'FFB266 float-center';
            } else if(difference> 200 && difference<300) {
              childNode.data[date].class = 'FF9933 float-center';
            } else if(difference> 300) {
              childNode.data[date].class = 'FF8000 float-center';
            }
          } else {
            childNode.data[date].cellStaus = false;
            childNode.data[date].class = '';
          }
          if(childNode.data[date].child30DayPercentageDiff >0 &&childNode.data[date].child30DayPercentageDiff > childNode.data[date].thresholdPercentage30Days) {
            childNode.data[date].cellTextColor = 'text-red';
          } else {
            childNode.data[date].cellTextColor = 'text-blue';
          }
          //Add color coding when the daily count is lower than 5 day
          if(childNode.data[date].value !== 0) {
            if(childNode.data[date].value < childNode.data['average5Days'].value*(1/4)) {
              childNode.data[date].cellStaus = true;
              childNode.data[date].class = 'FF99FF float-center';
            } else if(childNode.data[date].value < childNode.data['average5Days'].value*(1/2)){
              childNode.data[date].cellStaus = true;
              childNode.data[date].class = 'FFCCFF float-center';
            }
          }
          
        }); 
      });
  return node;
  }

  goToCatRoeViewer(rowData:any,col:any,value:any) {
    if(value< 20000) {
      if(rowData.fieldValue == 'False'){
        rowData.fieldValue = rowData.fieldValue.toLowerCase();
      }
 
      let urlParams = {
        "callFromScreen": "catanalytics",
        "reportDate": col.field,
        "activeMPID": this.userService.getActiveMPID(),
        "fieldName": rowData.fieldName,
        "fieldValue": rowData.fieldValue,
        "eventType": rowData.eventType,
        "groupName": rowData.groupName
      };

      /* Catch User Action Log */
      this.userService.logUserActivity("Reviewed CAT-ROE Records", null, {
        'Text1': this.userService.userFirstName + ' reviewed CAT-ROE records from CAT Analytics',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(urlParams)
      });
 
      this.router.navigate([]).then(result => {  window.open('/#/pages/CAT/CAT-ROE-Viewer?'+btoa(JSON.stringify(urlParams)), '_blank'); });
    } else {
      this.confirmationService.confirm({
        message: 'Number of records exceed maximum allowed count for the pop-up',
        key: 'informationDialoge',
        acceptLabel: 'Ok',
        acceptIcon:'pi pi-check',
        rejectLabel: 'No',
        rejectIcon:'pi pi-times',
        acceptButtonStyleClass:"information-dialog-button",
        rejectButtonStyleClass:"information-dialog-button",
        accept: () => {
        }
      });
    }
   
   
  }
  applyThreshold() {
    this.treeData = this.addthresholdPercentageForAll(this.treeData);
    this.treeData = [... this.treeData];
  }
 
  addthresholdPercentageForAll(nodes:any) {
    for (let node of nodes) {
    
        this.catAnalyticsDate.forEach((date) => {
          node.data[date].thresholdPercentage = node.data[date].parentPercentageDiff > 0 ?
            node.data[date].parentPercentageDiff + this.percentageChange : this.percentageChange;
        });
        if (node.children) {
        this.addthresholdPercentageForAll(node.children);
        node = this.highLightCell(node);
        }
         
      }
      return nodes;
    }
  
  formatTreeData(isChildNode: boolean, treeData:any, parent?:any) {
    treeData.forEach((element:any, index:any) => {
      if (isChildNode) {
        let gridArray:any = this.gridColumns;
        gridArray.forEach((item:any) => {
          if (treeData[index].data.fieldName === item.mappingkey) {
            treeData[index].data.isActiveLink = true;
          }
        });
        if (!element.data.eventType) {
          treeData[index].data.fieldNameValue = element.data.fieldValue;
        } else {
          treeData[index].data.fieldNameValue = element.data.eventType;
        }
        this.addDiffPercentageValue(treeData,index,isChildNode,parent);
      } else {
        treeData[index].data.fieldNameValue = element.data.fieldName;
        this.addDiffPercentageValue(treeData,index,isChildNode,parent);
      }
    });
    return treeData;
  }
  
  addThresholdPercentage(treeData:any,index:any) {
    this.catAnalyticsDate.forEach((date)=> {
       treeData[index].data[date].thresholdPercentage =   treeData[index].data[date].parentPercentageDiff> 0 ? 
             treeData[index].data[date].parentPercentageDiff+ this.percentageChange: this.percentageChange;
             treeData[index].data[date].thresholdPercentage30Days =   treeData[index].data[date].parent30DayPercentageDiff> 0 ? 
             treeData[index].data[date].parent30DayPercentageDiff+10: 10;
    })
  }

  addDiffPercentageValue(treeData:any,index:any,isChildNode:any,parent?:any) {
      treeData[index].data['average5Days'] = {value : treeData[index].data['average5Days']};
      treeData[index].data['average30Days'] = {value :  treeData[index].data['average30Days']};
      this.catAnalyticsDate.forEach((date)=> {
        let diff =  treeData[index].data[date] - treeData[index].data['average5Days'].value;
        let Diff30Days = treeData[index].data[date] - treeData[index].data['average30Days'].value;
        let diff5DaysPercentageValue = diff/treeData[index].data['average5Days'].value*100;
        let diff30DaysPercentageValue = Diff30Days/treeData[index].data['average30Days'].value*100;
          treeData[index].data[date] = {value : treeData[index].data[date],cellStaus: false};
          if(!isChildNode) {
            // parent 
            if(treeData[index].data['average5Days'].value >0) {
              treeData[index].data[date].parentPercentageDiff = diff5DaysPercentageValue;
              treeData[index].data[date].childPercentageDiff = diff5DaysPercentageValue;
            } else {
               //if average5Days <=0 - not apply color change to cell
              treeData[index].data[date].childPercentageDiff = 0;
            }
            if(treeData[index].data['average30Days'].value >0) {
              treeData[index].data[date].parent30DayPercentageDiff = diff30DaysPercentageValue;
              treeData[index].data[date].child30DayPercentageDiff = diff30DaysPercentageValue;
            } else {
               //if average5Days <=0 - not apply color change to cell
              treeData[index].data[date].child30DayPercentageDiff = 0;
            }
      
          } else {
            //  child for 5Days
            if(treeData[index].data['average5Days'].value >0) {
            treeData[index].data[date].parentPercentageDiff = parent.data[date].parentPercentageDiff;
            treeData[index].data[date].childPercentageDiff = diff5DaysPercentageValue;
            } else {
                 //if average5Days <=0 - not apply color change to cell
                treeData[index].data[date].childPercentageDiff = 0;
            }

             //  child for 30 Days
             if(treeData[index].data['average30Days'].value >0) {
              treeData[index].data[date].parent30DayPercentageDiff = parent.data[date].parent30DayPercentageDiff;
              treeData[index].data[date].child30DayPercentageDiff = diff30DaysPercentageValue;
              } else {
                   //if average5Days <=0 - not apply color change to cell
                  treeData[index].data[date].child30DayPercentageDiff = 0;
              }
          }
      })
      this.addThresholdPercentage(treeData,index);
  }

  ngOnDestroy() {
   this.ngUnsubscribe.next();
  }

  onContextMenu(event: any, params: any) {
    if(params.length > 0) {
      this.commentCriteria = params[0];
      this.commentField = params[1];
    }
    this.cm.target = event.currentTarget;
    this.cm.show(event);   
}
getDateEmitter(){
  this.reportDate = this.datepickerService.reportDate;
}
}